import { Box, Modal } from '@mui/material';
import { useEffect, useState } from 'react';
import { FaEdit } from 'react-icons/fa';
import {
  IoIosArrowDown,
  IoIosArrowForward,
  IoIosCheckmarkCircleOutline,
  IoMdAdd,
  IoMdCloseCircleOutline,
} from 'react-icons/io';
import useWindowSize from '../../../../hooks/useWindowSize';
import Pagination from '../../../../pages/Pricing/Pagination';
import Table from '../../../../components/Table';
import { MdAddTask } from 'react-icons/md';
import { dataTimezones } from '../../../../utils/Timezona';
import * as api from '../../../../services/api';
import { toast } from 'react-toastify';
import { DefaultMessage } from '../../../../utils/defaultMessages';
import { formatDateTime } from '../../../../utils/FormatDateTime/FormatDateTime';
import { motion } from 'framer-motion';

interface TableRowData {
  id: string;
  name: string;
  task: string;
  queue: string;
  priority: number | null | string;
  start_time: string;
  last_run_at: string;
  total_run_count: number;
  date_changed: string;
  description: string;
  interval: null | number;
  crontab: null | number;
  enabled: boolean | string;
  type_agendamento: string;
}

interface TableRowDataCrontab {
  id: number;
  minute: string;
  hour: string;
  day_of_month: string;
  month_of_year: string;
  day_of_week: string;
  timezone: string;
}

interface TaskData {
  id: number;
  task: string;
  args: string;
  name: string;
  queue: string;
  description: string;
  start_time: string;
  last_run_at: string;
  total_run_count: number;
  date_changed: string;
  type_agendamento: string;
  priority: number | null | string;
  enabled: boolean | string;
  crontab: number | undefined;
  interval: number | undefined;
}

interface TableRowDataInterval {
  id: number;
  every: string;
  period: string;
}

export default function Managing() {
  const [tableData, setTableData] = useState<TableRowData[]>();
  const [tableDataCrontab, setTableDataCrontab] =
    useState<TableRowDataCrontab[]>();
  const [tableDataInterval, setTableDataInterval] =
    useState<TableRowDataInterval[]>();

  const [currentPage, setCurrentPage] = useState<number>(1);
  const [currentPageInterval, setCurrentPageInterval] = useState<number>(1);
  const [currentPageCrontab, setCurrentPageCrontab] = useState<number>(1);

  const [totalPages, setTotalPages] = useState<number>(1);
  const [totalPagesInterval, setTotalPagesInterval] = useState<number>(1);
  const [totalPagesCrontab, setTotalPagesCrontab] = useState<number>(1);

  const [openModal, setOpenModal] = useState(false);
  const [openModalCrontab, setOpenModalCrontab] = useState(false);
  const [openModalInterval, setOpenModalInterval] = useState(false);
  const [optionsStateInterval, setOptionsStateInterval] = useState(false);
  const [optionsStateCrontab, setOptionsStateCrontab] = useState(false);

  const [formDataCrontab, setFormDataCrontab] =
    useState<TableRowDataCrontab | null>(null);
  const [formDataInterval, setFormDataInterval] =
    useState<TableRowDataInterval | null>(null);

  const { width } = useWindowSize();
  const [schedules, setSchedules] = useState<any>([]);
  const [timezones, setTimezones] = useState<any>([]);

  const [isEditing, setIsEditing] = useState(false);
  const [isEditingCrontab, setIsEditingCrontab] = useState(false);
  const [isEditingInterval, setIsEditingInterval] = useState(false);
  const [formData, setFormData] = useState<TaskData | null>(null);

  const [isClosingInterval, setIsClosingInterval] = useState(false);
  const [isClosingCrontab, setIsClosingCrontab] = useState(false);

  useEffect(() => {
    managingFile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (optionsStateInterval || formData) {
      DataTableInterval();
    }
    if (formData) {
      DataTableInterval(undefined, 90);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [optionsStateInterval, formData]);

  useEffect(() => {
    if (optionsStateCrontab) {
      DataTableCrontab();
    }
    if (formData) {
      DataTableCrontab(undefined, 90);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [optionsStateCrontab, formData]);

  useEffect(() => {
    if (formData?.type_agendamento) {
      if (formData.type_agendamento === 'interval') {
        DataTableInterval();
        setSchedules(tableDataInterval);
      } else {
        DataTableCrontab();
        setSchedules(tableDataCrontab);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData?.type_agendamento]);

  useEffect(() => {
    setTimezones(dataTimezones);
  }, [formDataCrontab]);

  const handleEdit = async (row: any) => {
    if (row) {
      setFormData(row);
      setIsEditing(true);
      setOpenModal(true);
    }
  };

  const handleInterval = () => {
    if (optionsStateInterval) {
      setIsClosingInterval(true);
      setTimeout(() => {
        setOptionsStateInterval(false);
        setIsClosingInterval(false);
      }, 500);
    } else {
      setOptionsStateInterval(true);
    }
  };
  const handleCrontab = () => {
    if (optionsStateCrontab) {
      setIsClosingCrontab(true);
      setTimeout(() => {
        setOptionsStateCrontab(false);
        setIsClosingCrontab(false);
      }, 500);
    } else {
      setOptionsStateCrontab(true);
    }
  };

  const handleEditCrontab = async (row: any) => {
    if (row) {
      setFormDataCrontab(row);
      setIsEditingCrontab(true);
      setOpenModalCrontab(true);
    }
  };
  const handleEditInterval = async (row: any) => {
    if (row) {
      setFormDataInterval(row);
      setIsEditingInterval(true);
      setOpenModalInterval(true);
    }
  };

  const handlePageChange = (newPage: number) => {
    setCurrentPage(newPage);
    managingFile(newPage);
  };
  const handlePageChangeInterval = (newPage: number) => {
    setCurrentPageInterval(newPage);
    DataTableInterval(newPage);
  };
  const handlePageChangeCrontab = (newPage: number) => {
    setCurrentPageCrontab(newPage);
    DataTableCrontab(newPage);
  };

  const columns = [
    { Header: 'Tarefa', accessor: 'task' },
    { Header: 'Nome', accessor: 'name' },
    { Header: 'Argumentos', accessor: 'args' },
    {
      Header: 'Fila',
      accessor: 'queue',
      Cell: ({value}: any) => (value === null ? '-' : value),
    },
    {
      Header: 'Prioridade',
      accessor: 'priority',
      Cell: ({value}:any) => (
        <div className="flex justify-center">
          {value === null ? <>-</> : <>{value}</>}
        </div>
      ),
    },
    {
      Header: 'Horário de início',
      accessor: 'start_time',
      Cell: ({value}: any) => (value === null ? '-' : formatDateTime(value)),
    },
    {
      Header: 'Última execução em',
      accessor: 'last_run_at',
      Cell: ({value}: any) => (value === null ? '-' : formatDateTime(value)),
    },
    { Header: 'Total de execuções', accessor: 'total_run_count' },
    {
      Header: 'Data de modificação',
      accessor: 'date_changed',
      Cell: ({value}: any) => (value === null ? '-' : formatDateTime(value)),
    },
    {
      Header: 'Descrição',
      accessor: 'description',
      Cell: ({value}: any) => (value === '' ? '-' : value),
    },
    {
      Header: 'Intervalo',
      accessor: 'interval',
      Cell: ({value}: any) => (value === null ? '-' : value),
    },
    {
      Header: 'Crontab',
      accessor: 'crontab',
      Cell: ({value}: any) => (value === null ? '-' : value),
    },
    {
      Header: 'Habilitado',
      accessor: 'enabled',
      Cell: ({value}: any) => (
        <div className="flex justify-center">
          {value ? (
            <IoIosCheckmarkCircleOutline size={20} className="text-[#00AEEF]" />
          ) : (
            <IoMdCloseCircleOutline size={20} className="text-red-400" />
          )}
        </div>
      ),
    },
  ];

  const columnsCrontab = [
    { Header: 'Id', accessor: 'id' },
    { Header: 'Minuto', accessor: 'minute' },
    { Header: 'Hora', accessor: 'hour' },
    { Header: 'Dia do mês', accessor: 'day_of_month' },
    { Header: 'Mês do ano', accessor: 'month_of_year' },
    { Header: 'Dia da semana', accessor: 'day_of_week' },
    { Header: 'Fuso horário', accessor: 'timezone' },
  ];

  const columnsInterval = [
    { Header: 'Id', accessor: 'id' },
    { Header: 'Número de períodos', accessor: 'every' },
    {
      Header: 'intervalo Período',
      accessor: 'period',
      Cell: (value: any) =>
        value === 'days'
          ? 'Dias'
          : value === 'hours'
            ? 'Horas'
            : value === 'minutes'
              ? 'Minutos'
              : value === 'seconds'
                ? 'Segundos'
                : value === 'microseconds' && 'Microssegundos',
    },
  ];

  const intervalPeriodOptions = [
    { id: 'days', value: 'Dias' },
    { id: 'hours', value: 'Horas' },
    { id: 'minutes', value: 'Minutos' },
    { id: 'seconds', value: 'Segundos' },
    { id: 'microseconds', value: 'Microssegundos' },
  ];

  const fetchData = async (
    url: string,
    setData: Function,
    setData_total_pages: Function,
  ) => {
    try {
      const response: any = await api.get(url);
      if (response.status === 200) {
        setData(response.data.results.results);
        setData_total_pages(response.data.results.total_pages);
      } else {
        toast.error(response.statusText, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } catch {
      toast.error(DefaultMessage.ERROR, { position: toast.POSITION.TOP_RIGHT });
    }
  };

  const submitData = async (
    method: 'post' | 'put',
    url: string,
    data: any,
    successMessage: string,
    callback: Function,
  ) => {
    try {
      const response: any = await api[method](url, data);
      if (response.status === 200 || response.status === 201) {
        toast.success(successMessage, { position: toast.POSITION.TOP_RIGHT });
        callback();
      } else {
        const content = response.data.content;

        if (content) {
          if (typeof content === 'object') {
            Object.keys(content).forEach((key) => {
              const value = content[key];

              if (Array.isArray(value)) {
                value.forEach((message: string) => {
                  const cleanMessage = message.replace(/^"|"$/g, '');
                  toast.error(cleanMessage, {
                    position: toast.POSITION.TOP_RIGHT,
                  });
                });
              } else {
                toast.error(value, { position: toast.POSITION.TOP_RIGHT });
              }
            });
          } else {
            toast.error(content, { position: toast.POSITION.TOP_RIGHT });
          }
        }
      }
    } catch {
      toast.error(DefaultMessage.ERROR, { position: toast.POSITION.TOP_RIGHT });
    }
  };

  const DataTableInterval = (
    currentPageInterval: number = 1,
    pageSize: number = 10,
  ) =>
    fetchData(
      `/periodic-tasks/schedules/interval/?page=${currentPageInterval}&page_size=${pageSize}`,
      setTableDataInterval,
      setTotalPagesInterval,
    );
  const DataTableCrontab = (
    currentPageCrontab: number = 1,
    pageSize: number = 10,
  ) =>
    fetchData(
      `/periodic-tasks/schedules/crontab/?page=${currentPageCrontab}&page_size=${pageSize}`,
      setTableDataCrontab,
      setTotalPagesCrontab,
    );
  const managingFile = (currentPage: number = 1) =>
    fetchData(
      `/periodic-tasks/periodic-tasks/?page=${currentPage}`,
      setTableData,
      setTotalPages,
    );

  const submitTask = async (e: any) => {
    e.preventDefault();
    if (!formData) return;

    const { start_time, ...rest } = formData;

    const dataSend = {
      ...rest,
      enabled: formData.enabled === 'true' ? true : false,
      crontab: formData.crontab === 0 ? null : formData.crontab,
      interval: formData.interval === 0 ? null : formData.interval,
      ...(isEditing
        ? {}
        : {
            args: JSON.stringify([formData.args]),
            task: 'task_execute_search_engines',
          }),
      ...(start_time !== '' ? { start_time } : {}),
    };

    const method = isEditing ? 'put' : 'post';
    const message = isEditing
      ? 'Tarefa editada com sucesso'
      : 'Tarefa criada com sucesso';
    const url = isEditing
      ? `/periodic-tasks/periodic-tasks/update/${formData.id}/`
      : '/periodic-tasks/periodic-tasks/create/';

    submitData(method, url, dataSend, message, () => {
      managingFile();
      setOpenModal(false);
      handlePageChange(1);
    });
  };

  const submitInterval = async (e: any) => {
    e.preventDefault();
    if (!formDataInterval) return;

    const { id, ...data } = formDataInterval;
    const dataSend = { interval: data, crontab: null };

    const method = isEditingInterval ? 'put' : 'post';
    const Message = isEditingInterval
      ? 'Interval editado com sucesso'
      : 'Interval criado com sucesso';
    const url = isEditingInterval
      ? `/periodic-tasks/schedules/update/interval/${id}/`
      : '/periodic-tasks/schedules/create/interval/';

    submitData(method, url, dataSend, Message, () => {
      DataTableInterval();
      setOpenModalInterval(false);
      handlePageChangeInterval(1);
    });
  };

  const submitCrontab = async (e: any) => {
    e.preventDefault();
    if (!formDataCrontab) return;

    const { id, ...data } = formDataCrontab;
    const dataSend = { crontab: data, interval: null };

    const method = isEditingCrontab ? 'put' : 'post';
    const Message = isEditingCrontab
      ? 'Crontab editado com sucesso'
      : 'Crontab criado com sucesso';
    const url = isEditingCrontab
      ? `/periodic-tasks/schedules/update/crontab/${id}/`
      : '/periodic-tasks/schedules/create/crontab/';

    submitData(method, url, dataSend, Message, () => {
      DataTableCrontab();
      setOpenModalCrontab(false);
      handlePageChangeCrontab(1);
    });
  };

  return (
    <div className="p-8">
      <h5 className="text-[24px] font-semibold text-gray-600 mb-12">
        GERENCIAMENTO DE FILA
      </h5>
      <div className="flex items-end justify-end">
        <button
          onClick={() => {
            setFormData({
              id: 0,
              task: '',
              args: '',
              name: '',
              queue: '',
              description: '',
              start_time: '',
              last_run_at: '',
              total_run_count: 0,
              date_changed: '',
              priority: null,
              type_agendamento: '',
              enabled: '',
              crontab: 0,
              interval: 0,
            });
            setIsEditing(false);
            setOpenModal(true);
          }}
          className=" bg-[#6fbf8c] text-white h-10 rounded-full w-full sm:w-max text-nowrap py-4 px-6 flex justify-center items-center text-[14px] font-semibold gap-2"
        >
          CRIAR TAREFA <IoMdAdd className="text-white" />
        </button>
      </div>
      <Table columns={columns} data={tableData} onEdit={handleEdit} />
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
      />

      <div className="flex items-center mt-8" onClick={handleInterval}>
        {optionsStateInterval ? <IoIosArrowDown /> : <IoIosArrowForward />}
        <button className="w-max font-semibold text-gray-600 px-4 py-2 rounded-full z-0">
          LISTA DE AGENDA INTERVALO
        </button>
      </div>

      <motion.div
        className=" transition-all duration-500"
        // layout
      >
        {optionsStateInterval && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{
              opacity: isClosingInterval ? 0 : 1,
              y: isClosingInterval ? -20 : 0,
              zIndex: isClosingInterval ? -1 : 0,
            }}
            transition={{ duration: 0.5 }}
          >
            <div className="flex items-end justify-end">
              <button
                onClick={() => {
                  setFormDataInterval({
                    id: 0,
                    every: '',
                    period: '',
                  });
                  setIsEditingInterval(false);
                  setOpenModalInterval(true);
                }}
                className=" bg-[#6fbf8c] text-white h-10 rounded-full w-full sm:w-max text-nowrap py-4 px-6 flex justify-center items-center text-[14px] font-semibold gap-2"
              >
                CRIAR AGENDA INTERVALO <IoMdAdd className="text-white" />
              </button>
            </div>
            <div className="w-full justify-center flex">
              <div className="w-full md:w-[50rem] md:flex md:flex-col md:justify-center md:items-center">
                <Table
                  columns={columnsInterval}
                  data={tableDataInterval}
                  onEdit={handleEditInterval}
                />
                <Pagination
                  currentPage={currentPageInterval}
                  totalPages={totalPagesInterval}
                  onPageChange={handlePageChangeInterval}
                />
              </div>
            </div>
          </motion.div>
        )}
      </motion.div>

      <div className="flex items-center" onClick={handleCrontab}>
        {optionsStateCrontab ? <IoIosArrowDown /> : <IoIosArrowForward />}
        <button className="w-max font-semibold text-gray-600 px-4 py-2 rounded-full z-0">
          LISTA DE AGENDA CRONTAB
        </button>
      </div>

      <motion.div
        className=" transition-all duration-500"
        // layout
      >
        {optionsStateCrontab && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{
              opacity: isClosingCrontab ? 0 : 1,
              y: isClosingCrontab ? -20 : 0,
              zIndex: isClosingCrontab ? -1 : 0,
            }}
            transition={{ duration: 0.5 }}
          >
            <div className="flex items-end justify-end">
              <button
                onClick={() => {
                  setFormDataCrontab({
                    id: 0,
                    minute: '',
                    hour: '',
                    day_of_month: '',
                    month_of_year: '',
                    day_of_week: '',
                    timezone: '',
                  });
                  setIsEditingCrontab(false);
                  setOpenModalCrontab(true);
                }}
                className=" bg-[#6fbf8c] text-white h-10 rounded-full w-full sm:w-max text-nowrap py-4 px-6 flex justify-center items-center text-[14px] font-semibold gap-2"
              >
                CRIAR AGENDA CRONTAB <IoMdAdd className="text-white" />
              </button>
            </div>
            <div className="w-full justify-center flex">
              <div className="w-full">
                <Table
                  columns={columnsCrontab}
                  data={tableDataCrontab}
                  onEdit={handleEditCrontab}
                />
                <Pagination
                  currentPage={currentPageCrontab}
                  totalPages={totalPagesCrontab}
                  onPageChange={handlePageChangeCrontab}
                />
              </div>
            </div>
          </motion.div>
        )}
      </motion.div>
      <Modal
        open={openModal}
        onClose={() => setOpenModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: 'white',
            padding: 4,
            borderRadius: 2,
            boxShadow: 3,
            width: width > 854 ? '50rem' : '90%',
            zIndex: 1300,
            maxHeight: '90vh',
            overflowY: 'auto',
          }}
        >
          {formData && (
            <div>
              {isEditing ? (
                <h3 className="font-bold text-xl mb-4 text-center">
                  <FaEdit />
                  Atualizar:{' '}
                  <span className="text-[#00AEEF]">{formData.name}</span>
                </h3>
              ) : (
                <h3 className="font-bold text-xl mb-4 text-center">
                  <MdAddTask /> Criar nova tarefa
                </h3>
              )}

              <form onSubmit={submitTask}>
                <div className="flex flex-col gap-4 md:flex-row md:justify-center">
                  <div className="w-full flex flex-col md:flex-row justify-center md:gap-4">
                    <div className="w-full">
                      <div className="mb-4">
                        <label className="block font-medium">Nome</label>
                        <input
                          required
                          type="text"
                          placeholder="name"
                          value={formData.name}
                          onChange={(e) =>
                            setFormData({ ...formData, name: e.target.value })
                          }
                          className="border rounded p-2 w-full"
                        />
                      </div>

                      {isEditing && (
                        <div className="mb-4">
                          <label className="block font-medium">Fila</label>
                          <input
                            type="text"
                            placeholder="queue"
                            value={formData.queue}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                queue: e.target.value,
                              })
                            }
                            className="border rounded p-2 w-full"
                          />
                        </div>
                      )}

                      <div className="mb-4">
                        <label className="block font-medium">Descrição</label>
                        <input
                          required
                          type="text"
                          placeholder="description"
                          value={formData.description}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              description: e.target.value,
                            })
                          }
                          className="border rounded p-2 w-full"
                        />
                      </div>
                      {isEditing ? (
                        <div className="mb-4">
                          <label className="block font-medium">
                            Horário de início
                          </label>
                          <input
                            type="datetime-local"
                            placeholder="start_time"
                            value={
                              formData.start_time
                                ? formData.start_time.slice(0, 16)
                                : ''
                            }
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                start_time: e.target.value,
                              })
                            }
                            className="border rounded p-2 w-full"
                          />
                        </div>
                      ) : (
                        <>
                          <div className="mb-4">
                            <label className="block font-medium">
                              Data e hora de início
                            </label>
                            <input
                              type="datetime-local"
                              placeholder="start_time"
                              value={formData.start_time}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  start_time: e.target.value,
                                })
                              }
                              className="border rounded p-2 w-full"
                            />
                          </div>
                        </>
                      )}

                      {isEditing && (
                        <div className="mb-4">
                          <label className="block font-medium">
                            Última execução em
                          </label>
                          <input
                            type="datetime-local"
                            placeholder="last_run_at"
                            value={
                              formData.last_run_at
                                ? formData.last_run_at.slice(0, 16)
                                : ''
                            }
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                last_run_at: e.target.value,
                              })
                            }
                            className="border rounded p-2 w-full"
                          />
                        </div>
                      )}
                    </div>
                    <div className="w-full">
                      {isEditing && (
                        <>
                          <div className="mb-4">
                            <label className="block font-medium">
                              Total de execuções
                            </label>
                            <input
                              required
                              type="text"
                              placeholder="total_run_count"
                              value={formData.total_run_count}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  total_run_count: Number(e.target.value),
                                })
                              }
                              className="border rounded p-2 w-full"
                            />
                          </div>
                          <div className="mb-4">
                            <label className="block font-medium">
                              Data de modificação
                            </label>
                            <input
                              required
                              type="datetime-local"
                              placeholder="date_change"
                              value={
                                formData.date_changed
                                  ? formData.date_changed.slice(0, 16)
                                  : ''
                              }
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  date_changed: e.target.value,
                                })
                              }
                              className="border rounded p-2 w-full"
                            />
                          </div>
                        </>
                      )}
                      <div className="mb-4">
                        <label className="block font-medium">Prioridade</label>
                        <input
                          type="number"
                          placeholder="Prioridade"
                          value={
                            formData.priority == null ? '' : formData.priority
                          }
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              priority: e.target.value,
                            })
                          }
                          className="border rounded p-2 w-full"
                        />
                      </div>
                      {isEditing ? (
                        <div className="mb-4">
                          {/* Seleção do Tipo de Agendamento */}
                          <label className="block font-medium">
                            Tipo de agendamento
                          </label>
                          <input
                            disabled={true}
                            type="text"
                            placeholder="agendamento"
                            value={
                              formData.interval !== undefined &&
                              formData.interval !== null
                                ? `Interval - id: ${formData.interval}`
                                : formData.crontab !== undefined &&
                                    formData.crontab !== null
                                  ? `Crontab - id: ${formData.crontab}`
                                  : 'Agendamento não definido'
                            }
                            className="border rounded p-2 w-full"
                          />
                        </div>
                      ) : (
                        <div className="mb-4">
                          <label className="block font-medium">
                            Tipo de agendamento
                          </label>
                          <select
                            required
                            className="border rounded p-2 w-full mb-4"
                            value={formData.type_agendamento}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                type_agendamento: e.target.value,
                              })
                            }
                          >
                            <option value="" disabled>
                              Selecione um tipo
                            </option>
                            <option value="interval">Intervalo</option>
                            <option value="crontab">Crontab</option>
                          </select>
                          <div>
                            <label className="block font-medium">
                              {formData.type_agendamento === ''
                                ? 'Agendamento'
                                : formData.type_agendamento === 'interval'
                                  ? 'Interval'
                                  : 'Crontab'}
                            </label>
                            <select
                              required
                              className="border rounded p-2 w-full"
                              value={
                                formData.type_agendamento === 'interval'
                                  ? formData.interval !== undefined
                                    ? formData.interval
                                    : ''
                                  : formData.crontab !== undefined
                                    ? formData.crontab
                                    : ''
                              }
                              onChange={(e) => {
                                const selectedId = Number(e.target.value); // Converte para número, se necessário

                                setFormData((prevState) => {
                                  if (!prevState) return null;

                                  return {
                                    ...prevState,
                                    [prevState.type_agendamento === 'interval'
                                      ? 'interval'
                                      : 'crontab']: selectedId,
                                  };
                                });
                              }}
                            >
                              <option value="">Selecione um agendamento</option>
                              {schedules.map((schedule: any) => (
                                <option key={schedule.id} value={schedule.id}>
                                  {schedule.id}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      )}
                      {isEditing && (
                        <div className="mb-4">
                          <label className="block font-medium">
                            Habilitado
                          </label>
                          <select
                            className="border rounded p-2 w-full"
                            value={formData.enabled.toString()}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                enabled: e.target.value,
                              })
                            }
                            name="enabled"
                            id="enabled"
                          >
                            <option value="" disabled selected>
                              Selecione
                            </option>

                            <option value="true">Sim</option>
                            <option value="false">Não</option>
                          </select>
                        </div>
                      )}
                      <div className="mb-4">
                        <label className="block font-medium">Args</label>
                        <input
                          required
                          type="text"
                          placeholder="semitrailer"
                          value={formData.args}
                          onChange={(e) =>
                            setFormData({ ...formData, args: e.target.value })
                          }
                          className="border rounded p-2 w-full"
                        />
                        <span className="text-gray-700">
                          'semitrailer', 'tractor', 'body_on_chassis', 'truck',
                          'planter', 'seeder', 'sprayer', 'roller_compactor',
                          'crane', 'mechanical_horse', 'backhoe',
                          'mini_excavator', 'loader', 'harvester',
                          'small_loader', 'crawler_tractor'.
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex w-full justify-center mt-8 gap-4">
                  <button
                    onClick={() => setOpenModal(false)}
                    className="bg-red-400 text-white h-10 rounded-full w-full sm:w-max text-nowrap py-4 px-6 flex justify-center items-center text-[14px] font-semibold"
                  >
                    CANCELAR
                  </button>
                  <button
                    type="submit"
                    className="bg-[#00AEEF] text-white h-10 rounded-full w-full sm:w-max text-nowrap py-4 px-6 flex justify-center items-center text-[14px] font-semibold"
                  >
                    {isEditing ? 'ALTERAR' : 'CRIAR'}
                  </button>
                </div>
              </form>
            </div>
          )}
        </Box>
      </Modal>

      <Modal
        open={openModalCrontab}
        onClose={() => setOpenModalCrontab(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: 'white',
            padding: 4,
            borderRadius: 2,
            boxShadow: 3,
            width: width > 854 ? '50rem' : '90%',
            zIndex: 1300,
            maxHeight: '90vh',
            overflowY: 'auto',
          }}
        >
          {formDataCrontab && (
            <div>
              {isEditingCrontab ? (
                <h3 className="font-bold text-xl mb-4 text-center">
                  <FaEdit />
                  Atualizar:{' '}
                  <span className="text-[#00AEEF]">{formDataCrontab.id}</span>
                </h3>
              ) : (
                <h3 className="font-bold text-xl mb-4 text-center">
                  <MdAddTask /> Criar nova agenda Crontab
                </h3>
              )}
              <form onSubmit={submitCrontab}>
                <div className="flex flex-col gap-4 md:flex-row md:justify-center">
                  <div className="w-full flex flex-col sm:flex-row justify-center gap-4">
                    <div className="w-full flex flex-col gap-4">
                      {isEditingCrontab && (
                        <div className="sm:h-[9rem]">
                          <label className="block font-medium">Id</label>
                          <input
                            required
                            type="text"
                            placeholder="id"
                            value={formDataCrontab.id || ''}
                            onChange={(e) =>
                              setFormDataCrontab({
                                ...formDataCrontab,
                                id: Number(e.target.value),
                              })
                            }
                            className="border rounded p-2 w-full"
                          />
                        </div>
                      )}
                      <div className="sm:h-[9rem]">
                        <label className="block font-medium">Minuto</label>
                        <input
                          required
                          type="text"
                          placeholder="0,30"
                          value={formDataCrontab.minute}
                          onChange={(e) =>
                            setFormDataCrontab({
                              ...formDataCrontab,
                              minute: e.target.value,
                            })
                          }
                          className="border rounded p-2 w-full"
                        />
                        <span className="text-gray-700">
                          Cron minutos para correr. Use "*" para "todos".
                        </span>
                      </div>

                      <div className="sm:h-[9rem]">
                        <label className="block font-medium">Hora</label>
                        <input
                          required
                          type="text"
                          placeholder="8,20"
                          value={formDataCrontab.hour}
                          onChange={(e) =>
                            setFormDataCrontab({
                              ...formDataCrontab,
                              hour: e.target.value,
                            })
                          }
                          className="border rounded p-2 w-full"
                        />
                        <span className="text-gray-700">
                          Horas cron para executar. Use "*" para "todos".
                        </span>
                      </div>
                      <div className="sm:h-[9rem]">
                        <label className="block font-medium">Dia do mês</label>
                        <input
                          required
                          type="text"
                          placeholder="1,15"
                          value={formDataCrontab.day_of_month}
                          onChange={(e) =>
                            setFormDataCrontab({
                              ...formDataCrontab,
                              day_of_month: e.target.value,
                            })
                          }
                          className="border rounded p-2 w-full"
                        />
                        <span className="text-gray-700">
                          Cron Dias do mês para correr. Use "*" para "todos".
                        </span>
                      </div>
                    </div>
                    <div className="w-full flex flex-col gap-4">
                      <div className="sm:h-[9rem]">
                        <label className="block font-medium">Mês do ano</label>
                        <input
                          required
                          type="text"
                          placeholder="1,12"
                          value={formDataCrontab.month_of_year}
                          onChange={(e) =>
                            setFormDataCrontab({
                              ...formDataCrontab,
                              month_of_year: e.target.value,
                            })
                          }
                          className="border rounded p-2 w-full"
                        />
                        <span className="text-gray-700">
                          Cron Meses (1-12) do ano para correr. Use "*" para
                          "todos".
                        </span>
                      </div>
                      <div className="sm:h-[9rem]">
                        <label className="block font-medium">
                          Dia da semana
                        </label>
                        <input
                          required
                          type="text"
                          placeholder="0,5"
                          value={formDataCrontab.day_of_week}
                          onChange={(e) =>
                            setFormDataCrontab({
                              ...formDataCrontab,
                              day_of_week: e.target.value,
                            })
                          }
                          className="border rounded p-2 w-full"
                        />
                        <span className="text-gray-700">
                          Cron Dias da Semana para Correr. Use "*" para "todos",
                          domingo é 0 ou 7, segunda-feira é 1.
                        </span>
                      </div>
                      <div className="sm:h-[9rem]">
                        <label className="block font-medium">
                          Fuso horário
                        </label>
                        <select
                          value={formDataCrontab.timezone}
                          onChange={(e) =>
                            setFormDataCrontab({
                              ...formDataCrontab,
                              timezone: e.target.value,
                            })
                          }
                          className="border rounded p-2 w-full"
                          name="timezone"
                          id="timezone"
                        >
                          <option value="" disabled>
                            Fuso horários
                          </option>
                          {timezones.map((timezone: any) => (
                            <option key={timezone} value={timezone}>
                              {timezone}
                            </option>
                          ))}
                        </select>
                        <span className="text-gray-700">
                          Fuso horário para executar o agendamento do cron. O
                          padrão é UTC.
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex w-full justify-center mt-8 gap-4">
                  <button
                    onClick={() => setOpenModalCrontab(false)}
                    className="bg-red-400 text-white h-10 rounded-full w-full sm:w-max text-nowrap py-4 px-6 flex justify-center items-center text-[14px] font-semibold"
                  >
                    CANCELAR
                  </button>
                  <button className="bg-[#00AEEF] text-white h-10 rounded-full w-full sm:w-max text-nowrap py-4 px-6 flex justify-center items-center text-[14px] font-semibold">
                    {isEditingCrontab ? 'ALTERAR' : 'CRIAR'}
                  </button>
                </div>
              </form>
            </div>
          )}
        </Box>
      </Modal>

      <Modal
        open={openModalInterval}
        onClose={() => setOpenModalInterval(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: 'white',
            padding: 4,
            borderRadius: 2,
            boxShadow: 3,
            width: width > 854 ? '50rem' : '90%',
            zIndex: 1300,
            maxHeight: '90vh',
            overflowY: 'auto',
          }}
        >
          {formDataInterval && (
            <div>
              {isEditingInterval ? (
                <h3 className="font-bold text-xl mb-4 text-center">
                  <FaEdit />
                  Atualizar:{' '}
                  <span className="text-[#00AEEF]">{formDataInterval.id}</span>
                </h3>
              ) : (
                <h3 className="font-bold text-xl mb-4 text-center">
                  <MdAddTask /> Criar nova agenda Interval
                </h3>
              )}
              <form onSubmit={submitInterval}>
                <div className="flex flex-col gap-4 md:flex-row md:justify-center">
                  <div className="w-full flex flex-row justify-center gap-4">
                    <div className="w-full flex flex-col gap-4">
                      {isEditingInterval && (
                        <div>
                          <label className="block font-medium">Id</label>
                          <input
                            required
                            type="text"
                            placeholder="id"
                            value={formDataInterval.id || ''}
                            onChange={(e) =>
                              setFormDataInterval({
                                ...formDataInterval,
                                id: Number(e.target.value),
                              })
                            }
                            className="border rounded p-2 w-full"
                          />
                        </div>
                      )}
                      <div>
                        <label className="block font-medium">
                          Números de períodos
                        </label>
                        <input
                          required
                          type="number"
                          placeholder="1"
                          value={formDataInterval.every}
                          onChange={(e) =>
                            setFormDataInterval({
                              ...formDataInterval,
                              every: e.target.value,
                            })
                          }
                          className="border rounded p-2 w-full"
                        />
                        <span className="text-gray-700">
                          Número de períodos de intervalo a esperar antes de
                          executar a tarefa novamente
                        </span>
                      </div>

                      <div>
                        <label className="block font-medium">
                          Período de intervalo
                        </label>
                        <select
                          required
                          className="border rounded p-2 w-full"
                          value={formDataInterval.period}
                          onChange={(e) =>
                            setFormDataInterval({
                              ...formDataInterval,
                              period: e.target.value,
                            })
                          }
                        >
                          <option value="" disabled>
                            Tipos de periodos
                          </option>
                          {intervalPeriodOptions.map((options) => (
                            <option key={options.id} value={options.id}>
                              {options.value}
                            </option>
                          ))}
                        </select>
                        <span className="text-gray-700">
                          O tipo de período entre as execuções de tarefas
                          (exemplo: dias)
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex w-full justify-center mt-8 gap-4">
                  <button
                    onClick={() => setOpenModalInterval(false)}
                    className="bg-red-400 text-white h-10 rounded-full w-full sm:w-max text-nowrap py-4 px-6 flex justify-center items-center text-[14px] font-semibold"
                  >
                    CANCELAR
                  </button>
                  <button className="bg-[#00AEEF] text-white h-10 rounded-full w-full sm:w-max text-nowrap py-4 px-6 flex justify-center items-center text-[14px] font-semibold">
                    {isEditingInterval ? 'ALTERAR' : 'CRIAR'}
                  </button>
                </div>
              </form>
            </div>
          )}
        </Box>
      </Modal>
    </div>
  );
}
